/**
 * Abyss Theme Configuration
 * UHG Blue primary color: rgb(0,38,119)
 */
import { createTheme } from '@uhg-abyss/web/tools/theme';

// Create UHC theme from Abyss preset
export const theme = createTheme('uhc');

// UHG Brand Colors
export const colors = {
  uhgBlue: 'rgb(0,38,119)',
  uhgBlueHover: 'rgb(0,48,139)',
  uhgBlueLight: 'rgb(0,58,159)',
  uhgBlueDark: 'rgb(0,28,99)',
};
